import { ChannelSettingsProvider } from '@sendbird/uikit-react/ChannelSettings/context';
import { type ChannelSettingsContextProps } from '@sendbird/uikit-react/ChannelSettings/context';
import { GroupCustomChannelSettingsUI } from './GroupCustomChannelSettingsUI';
import { useLeaveChannel } from '../../../api/hooks/sendbird/useLeaveChannel';

export const GroupCustomChannelSettings = (
  props: ChannelSettingsContextProps
) => {
  const { mutateAsync: leaveChannelAsync } = useLeaveChannel();

  const handleLeaveChannel = async () => {
    if (props.channelUrl) {
      await leaveChannelAsync({ channelUrl: props.channelUrl });
    }
  };

  const handleLeaveChannelSync = () => {
    handleLeaveChannel().catch(() => {
      // Error handling is done in the hook, so we can ignore it here
    });
  };

  return (
    <ChannelSettingsProvider {...props} onLeaveChannel={handleLeaveChannelSync}>
      <GroupCustomChannelSettingsUI />
    </ChannelSettingsProvider>
  );
};
